import { IShippingPrice } from '@/models/shippingPrice.model';

export const getStatesOptions = (states?: IShippingPrice[] | null) =>
  states?.map(({ name, id }) => ({ value: id, label: name }));

export const getStatesCodeOptions = (states?: IShippingPrice[] | null) =>
  states?.map(({ name, code }) => ({ value: code, label: name }));
